import React, { Component } from "react";
import * as s from "./SectionsContainer.module.scss";
import { inject, observer } from "mobx-react";
import { SectionsContainerStore } from "src/stores";
import { withStore } from "src/libs/mobx";
import { CookiesModal } from "src/views/shared/modals";
interface Props extends React.HTMLAttributes<HTMLDivElement> {
  template?:
    | "page_builder"
    | "document_builder"
    | "article_builder"
    | "collection_builder"
    | "search_page"
    | "userCollection_builder"
    | "term_builder"
    | "toolkit_builder";
  sectionsContainerStore?: SectionsContainerStore;
}

@inject("sectionsContainerStore")
@observer
export class SectionsContainer extends Component<Props> {
  render() {
    const { template, sectionsContainerStore, children } = this.props;

    const { hasOpenOverlay } = sectionsContainerStore;

    let classes = [s.sectionsContainer];

    switch (template) {
      case "page_builder":
        classes.push(s.pageTemplate);
        break;
      case "document_builder":
        classes.push(s.documentTemplate);
        break;
      case "article_builder":
        classes.push(s.articleTemplate);
        break;
      case "collection_builder":
        classes.push(s.collectionTemplate);
        break;
      case "userCollection_builder":
        classes.push(s.userCollectionTemplate);
        break;
      case "term_builder":
        classes.push(s.collectionTemplate);
        break;
      case "toolkit_builder":
        classes.push(s.collectionTemplate);
        break;
    }

    if (hasOpenOverlay) classes.push("hasOpenOverlay");

    return (
      <>
        <div className={classes.join(" ")}>{children}</div>
        <CookiesModal />
      </>
    );
  }
}

export default withStore(SectionsContainer);
